export const Pagination = `{
  next{page, limit }
  prev{page, limit }
}`;

const SubjectInfo = `{
  pvid
  subject
}`;

const UserInfo = `{
  pvid
  email
  token
  country
  firstName
  lastName
  phone
  address
  profileImage
}`;

export const File = `{
  pvid
  path
  fileName
  mimeType
  resourceTypePvid
  encoding
  eTag
  durationSecs
  resourceInfoPvid
}`;

export const ReviewInfo = `{
  pvid
  reviewTitle
  reviewContent
  authorName
  authorPicture
  createdAt
  rating
}`;

export const Content = `
  pvid
  title
  description
  purchaseLimit
  tags
  numberOfViews
  numberOfReviews
  rating
  numberOfSales
  currency
  publish
  removeReason
  createdAt
  subjectInfo ${SubjectInfo}
  tutor ${UserInfo}
  contentResPreview ${File}
  reviews {
    pvid
    reviewTitle
    reviewContent
    authorName
    authorPicture
    createdAt
    rating
  }
  numberOfDownloads

  tiers{
    id
 title
 description
 price
 commission
 earnings
 createdAt
 resource{
   pvid
   mimeType
 }
 }
`;

export const SearchItems = `
  count,
  total,
  pagination ${Pagination}
  data {${Content}}
`;
